// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* The one Curio tooltip: a white card over the page, the same size at every
   canvas zoom, since it is drawn on document.body from on-screen boxes. Its
   max width and height come from tooltipPlacement.ts, as inline styles. */
.IPaAAFc0ujUxvMFSNatR {
  position: fixed;
  left: 0;
  top: 0;
  z-index: var(--curio-z-tooltip);
  box-sizing: border-box;
  background: var(--curio-card-bg);
  color: var(--curio-text-primary);
  border: 1px solid var(--curio-border-strong);
  border-radius: var(--curio-radius-md);
  box-shadow: var(--curio-shadow-tooltip);
  font-family: var(--curio-font-family);
  font-size: var(--curio-font-size-sm);
  line-height: var(--curio-line-height-sm);
  font-weight: 400;
  text-align: left;
  overflow-wrap: anywhere;
  pointer-events: auto;
}

/* Plain text: the attribute's own line breaks kept, as a chart's "field:
   value" lines need. */
.zOhNIvOjvizix96AJYkF {
  padding: 4px 8px;
  white-space: pre-line;
}

/* One at the pointer (a chart's) sits just above it: the pointer goes
   through to the marks under it, so moving up never lands on it. */
.dp3Xbd1hed8q2YsCufNr {
  pointer-events: none;
}

/* Content a target registered: cut to its size, never scrolled. */
.Y8KztQYSjweflcO4jHMX {
  padding: 8px 10px;
  overflow: hidden;
}

/* What a rich tooltip says under its first line: secondary text. */
.Y8KztQYSjweflcO4jHMX .curio-tooltip-muted {
  color: var(--curio-text-secondary);
}
`, "",{"version":3,"sources":["webpack://./src/components/tooltip/TooltipLayer.module.css"],"names":[],"mappings":"AAAA;;0EAE0E;AAC1E;EACE,eAAe;EACf,OAAO;EACP,MAAM;EACN,+BAA+B;EAC/B,sBAAsB;EACtB,gCAAgC;EAChC,gCAAgC;EAChC,4CAA4C;EAC5C,qCAAqC;EACrC,uCAAuC;EACvC,qCAAqC;EACrC,oCAAoC;EACpC,wCAAwC;EACxC,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;uBACuB;AACvB;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;mEACmE;AACnE;EACE,oBAAoB;AACtB;;AAEA,kEAAkE;AAClE;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,mEAAmE;AACnE;EACE,kCAAkC;AACpC","sourcesContent":["/* The one Curio tooltip: a white card over the page, the same size at every\n   canvas zoom, since it is drawn on document.body from on-screen boxes. Its\n   max width and height come from tooltipPlacement.ts, as inline styles. */\n.tooltip {\n  position: fixed;\n  left: 0;\n  top: 0;\n  z-index: var(--curio-z-tooltip);\n  box-sizing: border-box;\n  background: var(--curio-card-bg);\n  color: var(--curio-text-primary);\n  border: 1px solid var(--curio-border-strong);\n  border-radius: var(--curio-radius-md);\n  box-shadow: var(--curio-shadow-tooltip);\n  font-family: var(--curio-font-family);\n  font-size: var(--curio-font-size-sm);\n  line-height: var(--curio-line-height-sm);\n  font-weight: 400;\n  text-align: left;\n  overflow-wrap: anywhere;\n  pointer-events: auto;\n}\n\n/* Plain text: the attribute's own line breaks kept, as a chart's \"field:\n   value\" lines need. */\n.text {\n  padding: 4px 8px;\n  white-space: pre-line;\n}\n\n/* One at the pointer (a chart's) sits just above it: the pointer goes\n   through to the marks under it, so moving up never lands on it. */\n.through {\n  pointer-events: none;\n}\n\n/* Content a target registered: cut to its size, never scrolled. */\n.rich {\n  padding: 8px 10px;\n  overflow: hidden;\n}\n\n/* What a rich tooltip says under its first line: secondary text. */\n.rich :global(.curio-tooltip-muted) {\n  color: var(--curio-text-secondary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tooltip": `IPaAAFc0ujUxvMFSNatR`,
	"text": `zOhNIvOjvizix96AJYkF`,
	"through": `dp3Xbd1hed8q2YsCufNr`,
	"rich": `Y8KztQYSjweflcO4jHMX`
};
export default ___CSS_LOADER_EXPORT___;
